
// Init
var biro_google_maps = [];


/**
 * Initialise Google maps callback
 */
function biro_google_maps_init() {

	// Init
	var map_count = 1;

	// Find all maps on page
	jQuery( '.google-map' ).each( function() {

		// Init
		var $el = jQuery( this );
		var map, marker_details, marker, center, zoom;

		// Get details from attributes
		center = {
			lat: parseFloat( $el.attr( 'data-center-lat' ) ),
			lng: parseFloat( $el.attr( 'data-center-lng' ) ),
		};
		if ( $el.attr( 'data-zoom' ) ) {
			zoom = parseInt( $el.attr( 'data-zoom' ) );
		} else {
			zoom = 10;
		}

		// Add map
		map = new google.maps.Map( this, {
			center: center,
			zoom: zoom,
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
		} );
		biro_google_maps[ map_count ] = map;

		// Add marker for center?
		if ( $el.attr( 'data-marker' ) === 'yes' ) {
			marker_details = {
				position: center,
				map: biro_google_maps[ map_count ],
				icon: {
					url: biro_main.img_url + 'map-marker.svg?v=2'
				},
			};
			if ( $el.attr( 'data-label' ) ) {
				marker_details[ 'label' ] = {
					text: $el.attr( 'data-label' ),
					fontSize: '15px',
					className: 'map-marker-label',
				};
				marker_details[ 'icon' ][ 'labelOrigin' ] = { x: 12, y: 50 };
			}
			marker = new google.maps.Marker( marker_details );
		}

		map_count++;

	});

}
